export const state = {
  driverLogs: {},
};
